import React, { Component } from 'react';
import axios from 'axios';
import { withRouter } from "react-router-dom";
import { withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Popover, PopoverHeader, PopoverBody } from 'reactstrap';

/* Gets configuration for Linkedin Api */
import { notification } from 'antd';
import { clienID, secretKey, callBackUrl, accessTokenRoute, userDetailsRoute } from '../../_constants';

class CustomLinkedIN extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loginStatus: false,
            popoverOpen: false,
            propsDetails:(this.props&&this.props.location&&this.props.location.state)
        }
        // const scopeParam = "r_emailaddress,r_liteprofile,";
        const scopeParam = "email,profile,openid,r_basicprofile";
        /* Url for getting authorization code */
       // console.log("propsprops.props", this.props);
        this.winUrl = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clienID}&redirect_uri=${callBackUrl}&scope=${scopeParam}&state=98765EeFWf45A53sdfKef4233`;
        this.linkedinRequest = this.linkedinRequest.bind(this);
        this.getParameterByName = this.getParameterByName.bind(this);
        this.toggle = this.toggle.bind(this);

    }

    /* Function to set name and achieve code value from its parameters */
    getParameterByName(name, search) {
        const match = RegExp('[?&]' + name + '=([^&]*)').exec(search);
        return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
    }

    toggle() {
        this.setState({
            popoverOpen: !this.state.popoverOpen
        });
    }

    /* Function that will fire all the request for getting access token and user details of the person login in */
    linkedinRequest() {
        /* Creates a new Window */
        const newWindow = window.open(this.winUrl, 'popUpWindow', 'height=550,width=430,left=480,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes');
        if (window.focus) {
            newWindow.focus();
        }
        const intr = setInterval(() => {
            if (newWindow.closed) {
                clearInterval(intr);
            }
            let search;
            try {
                search = newWindow.location.search;
            } catch (e) {
                // we are ignoring this because the error is going to be CORS related
            }

            if (search) {
                // grab the token and error from the location of the popup window
                const authCode = this.getParameterByName('code', search);
                const linkedInAuthCode = authCode;
                /* LinkedIn Base url */
                /* Sending Request object to server js file where the actual request is going to get fire for access token */
                const REQ_OBJECT = {
                    'grant_type': 'authorization_code',
                    'code': linkedInAuthCode,
                    'redirect_uri': callBackUrl,
                    'client_id': clienID,
                    'client_secret': secretKey
                };

                /* Axios request for Getting Access Tokens */
                axios.post(accessTokenRoute, REQ_OBJECT)
                    .then((accessTokens) => {
                        const accessToken = accessTokens.data;
                        const peopleUrl = userDetailsRoute;
                        const sentData = {
                            'oauth2_access_token': accessToken
                        };
                        /* Axios request for Getting Linkedin User details */
                        axios.post(peopleUrl, sentData)
                            .then((success) => {
                                if (success.data && success.data.statusCode === 500) {
                                    notification.error({
                                        message: "Your Account Is Detactivate",
                                        className:'errorNotification',
                                        duration: 3
                                    });
                                }
                                const userInfo = success.data.response;
                                if(userInfo.loginStatus) {
                                    var redirectPage = ""
                                    if(userInfo&&userInfo.userData.userType === "subUser") {
                                        localStorage.setItem('userData', JSON.stringify(userInfo.userData))
                                        localStorage.setItem('JWTTOKEN', userInfo.userData.token)
                                        localStorage.setItem('userLogin', true)
                                        this.props.history.push({
                                            pathname: "/dashboard-home",
                                            state: { "userInfo": userInfo }
                                        });
                                    }else{
                                        localStorage.setItem('userData', JSON.stringify(userInfo.userData))
                                        localStorage.setItem('JWTTOKEN', userInfo.userData.token)
                                        localStorage.setItem('userLogin', true)
                                        if(userInfo.userData && userInfo.userData.userType === "user") {
                                            redirectPage = this.props.history.location.pathname
                                            
                                        }else{
                                            redirectPage = "/dashboard-home"
                                        }

                                        this.props.history.push({
                                            pathname: redirectPage,
                                            state:this.state.propsDetails
                                        });
                                        notification.success({
                                            message: "Signed in successfully",
                                            className:'successNotification',
                                            duration: 3
                                        });
                                    }
                                }else if(!userInfo.loginStatus) {
                                    const { useFor } = this.props;
                                    if(useFor === "verify") {
                                        this.props.history.push({
                                            pathname: "/sub-user-verify",
                                            state: { "userInfo": userInfo }
                                        });
                                    }else{
                                        this.props.history.push({
                                            pathname: "/sign-up",
                                            state: { "userInfo": userInfo }
                                        });
                                    }
                                }
                            })
                            .catch((errored) => {
                                console.log("errored", errored);
                            });
                    })
                    .catch((errors) => {
                        console.log("errors", errors);
                    });
                /* This will close the window popup automatically once all the above requests are completed */
                newWindow.close();
            }
        }, 100);
    }

    /* Render function to create a structure for linkedin button */
    render() {
        const { textTtile } = this.props;
        return (
            <div className="social-button-block">
                <span title="Connect With LinkedIn" onClick={this.linkedinRequest}>
                    <a className="btn btn-social btn-linkedin">
                        <i className="fa fa-linkedin"></i> {textTtile}
                    </a>
                </span>
                { /*<span className="radio-signups pop-I"  id="Popover1" >
                  <i class="fa fa-info passIcon"  aria-hidden="true"></i>
                </span>
                <Popover placement="right-start" trigger="hover" isOpen={this.state.popoverOpen} target="Popover1" toggle={this.toggle}>
                  <PopoverHeader>Why we choose LinkedIn SignIn</PopoverHeader>
                  <PopoverBody>We believe this is more secure than regular email and password. Users do not have to share passwords or create passwords with us.<br/>
                        Many users have passwords common at multiple websites which can be dangerous.<br/>
                        Also, LinkedIn shares minimal data with us when user registers with us using LinkedIn. They do not share the password with us.
                        LinkedIn also has tools to better validate the users.
                  </PopoverBody>
                </Popover>*/}
                {/*  <p className="linkedin-text">Connect with your personal LinkedIn account</p>*/}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {}
}
/* Exporting the CustomLinkedIn Component Just need to import this component wherever needed */
export default withLocalize(withRouter(connect(mapStateToProps, {})(CustomLinkedIN)));;


// WEBPACK FOOTER //
// ./src/components/Linkdin/CustomLinkedIN.js